import { checkUserHasAdminRole, checkUserHasClientRole, checkUserHasManagerRole, checkUserHasMemberRole } from "app/services/app.state.service"
import { LeavePlanClientView } from "app/components/leave-plans/LeavePlanClientView"
import { LeavePlanForMemberView } from "app/components/leave-plans/LeavePlanForMemberView"
import { LeavePlanAdminView } from "app/components/leave-plans/LeavePlanAdminView"
import { LeavePlanManagerView } from "app/components/leave-plans/LeavePlanManagerView"

export const LeavePlanRouterFactory = () => {
    if(checkUserHasAdminRole()) {
        return <LeavePlanAdminView />
    }

    else if(checkUserHasManagerRole()) {
        return <LeavePlanManagerView />
    }

    else if(checkUserHasClientRole()) {
        return <LeavePlanClientView />
    }

    else if(checkUserHasMemberRole()) {
        return <LeavePlanForMemberView />
    }
        
    else {
        window.location.href = "/login";
    } 
}